"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* What a template is filled with in a chat: its patients, the sender, the
 * org, and {{team_name}} as the team the message goes out as (the channel
 * line's rule). The picker inserts with it and both editors' Preview reads
 * it, so the two always agree. */
var _react = require('react');



var _typed = require('shared/hooks/typed');
var _blobject = require('shared/selectors/blobject');
var _common = require('shared/selectors/blobject/common/common');
var _conversation = require('shared/selectors/conversation');
var _messageTemplate = require('shared/selectors/messageTemplate');
var _myRelations = require('shared/selectors/myRelations');
var _team = require('shared/selectors/team');
var _composer = require('shared/services/composer');
var _templateSendingTeam = require('shared/services/templateSendingTeam');


 const useChatTemplateContext = (orgKey, blobjectKey) => {
  const chatContext = _typed.useAppSelector.call(void 0, state => _messageTemplate.selectTemplateContext.call(void 0, state, blobjectKey, orgKey))
  const teams = _typed.useAppSelector.call(void 0, _team.selectTeams)
  const myTeamKeys = _typed.useAppSelector.call(void 0, _myRelations.selectMyTeamKeys)
  const conversationType = _typed.useAppSelector.call(void 0, state => _conversation.selectConversationType.call(void 0, state, blobjectKey))
  const sendingNumber = _typed.useAppSelector.call(void 0, state => _blobject.selectSendingNumber.call(void 0, state, blobjectKey))
  const chatTeams = _typed.useAppSelector.call(void 0, state => _optionalChain([_common.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _ => _.TeamSubscribers]))
  const teamNames = _react.useMemo.call(void 0, 
    () => Object.fromEntries(Object.values(_nullishCoalesce(teams, () => ( {}))).map(t => [t.TeamKey, t.Name])),
    [teams],
  )
  return _react.useMemo.call(void 0, () => ({
    ...chatContext,
    teamName: _templateSendingTeam.templateTeamName.call(void 0, {
      channel: _composer.composerChannelFor.call(void 0, conversationType),
      sendingNumber,
      chatTeamKeys: Object.keys(_nullishCoalesce(chatTeams, () => ( {}))),
      myTeamKeys,
      teamNames,
    }),
  }), [chatContext, conversationType, sendingNumber, chatTeams, myTeamKeys, teamNames])
}; exports.useChatTemplateContext = useChatTemplateContext
